import { useCallback, useState } from 'react';
import type { TareasCountSource } from '../types';

export interface UseTramiteTareasDialogReturn<T extends TareasCountSource> {
  isOpen: boolean;
  selectedTramite: T | null;
  openDialog: (tramite: T) => void;
  closeDialog: () => void;
}

/** Copia de `useTramiteStatusDialog`, generalizada al tipo de trámite. */
export function useTramiteTareasDialog<
  T extends TareasCountSource = TareasCountSource
>(): UseTramiteTareasDialogReturn<T> {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTramite, setSelectedTramite] = useState<T | null>(null);

  const openDialog = useCallback((tramite: T) => {
    setSelectedTramite(tramite);
    setIsOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setIsOpen(false);
    setSelectedTramite(null);
  }, []);

  return { isOpen, selectedTramite, openDialog, closeDialog };
}

export default useTramiteTareasDialog;
